import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-legend" }
const _hoisted_2 = { key: 2 }

import ColorLegendContinuous from './ColorLegendContinuous.vue'
import ColorLegendCategorical from './ColorLegendCategorical.vue'
import { FormatOptions } from '@/components/AnalyticsDashboard/formatter'
import { computed } from 'vue'
import { LocaleString } from '@/api-client/models/utilization/Contracts'
import useColoredEntities from '@/composables/useColoredEntities'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'

type Color = {
  color: string
  label?: LocaleString
}

type Props = {
  title: string
  width?: number
  height?: number
  padding?: number
  colors?: Color[]
  format?: FormatOptions
  value?: number
  kpi?: string
  hideMean?: boolean
  labelStart?: string
  labelEnd?: string
  errorMessage?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorLegend',
  props: {
    title: {},
    width: { default: 288 },
    height: { default: 64 },
    padding: { default: 20 },
    colors: { default: undefined },
    format: { default: undefined },
    value: { default: undefined },
    kpi: { default: undefined },
    hideMean: { type: Boolean },
    labelStart: { default: undefined },
    labelEnd: { default: undefined },
    errorMessage: { default: undefined }
  },
  setup(__props: any) {

const props = __props
const { colorScale, mean } = storeToRefs(useColoredEntities())
const { t } = useI18n()

const colors = computed(() => {
  if (props.colors) {
    return props.colors
  }
  if (colorScale.value.type === 'STEP') {
    const colors = colorScale.value?.cutoffs.map(({ color, label }) => ({
      color,
      label
    }))
    return colors ?? []
  }
  return []
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
    (_unref(colorScale) && _unref(colorScale).type === 'INTERPOLATE')
      ? (_openBlock(), _createBlock(ColorLegendContinuous, {
          key: 0,
          id: "color-legend-continuous",
          width: _ctx.width,
          height: _ctx.height,
          padding: _ctx.padding,
          mean: _unref(mean) ?? _ctx.value,
          colorScale: _unref(colorScale),
          formatOptions: _ctx.format,
          hideMean: _ctx.hideMean,
          labelStart: _ctx.labelStart,
          labelEnd: _ctx.labelEnd
        }, null, 8, ["width", "height", "padding", "mean", "colorScale", "formatOptions", "hideMean", "labelStart", "labelEnd"]))
      : (colors.value)
        ? (_openBlock(), _createBlock(ColorLegendCategorical, {
            key: 1,
            id: "color-legend-categorical",
            width: _ctx.width,
            height: _ctx.height,
            kpi: _ctx.kpi,
            colors: colors.value
          }, null, 8, ["width", "height", "kpi", "colors"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorMessage ?? _unref(t)('general__text__dashboard_somethings_missing')), 1))
  ]))
}
}

})